import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,

  Form,
  Input,
  Button,
  Layout,
  Upload,
  Select,
  Image,
  Modal,
  DatePicker,
  Skeleton,
  message,
  Checkbox,
  Divider,
} from "antd";
import dayjs from "dayjs";
import { UploadOutlined, FileTextOutlined, FilePdfOutlined, CloseOutlined } from "@ant-design/icons";
import { FaArrowLeft } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { CONTENT_TYPE } from "../../config/constants";
import {
  UPLOADS_URL,
  COURSE,
  CATEGORIES,
  LECTURES,
} from "../../config/constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import swal from "sweetalert";
import { ImageUrl } from "../../helpers/Functions";
import { Delete } from "../../config/api";
import Comments from "../../components/Comments";
import { AiFillDelete } from "react-icons/ai";
import VideoPlayer from "../../components/VideoPlayer2";
const { Option } = Select;


function CourseDetails() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [categories, setCategories] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [imageNew, setImageNew] = useState();
  const [fileList, setFileList] = useState([]);
  const [, setLectures] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [deleteVideo, setDeleteVideo] = useState(false);
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [deleteThumbnail, setDeleteThumbnail] = useState(false);
  useEffect(() => {
    getCourse();
    getCategories();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getAllLectures();
    //eslint-disable-next-line
  }, []);

  const getAllLectures = async () => {
    const res = await Get(LECTURES.getAllLecturesByCourse + id, token);

    setLectures(res.data.docs);
  };

  const getCourse = async () => {
    setLoading(true);
    const res = await Get(`${COURSE.getCourseById}${id}`, token);


    const courseData = res.data.course;
    setCourse(courseData);
    setLoading(false);
    setFileList(createFileList(courseData?.files));
    
    // Initialize single video from fileUrl
    if (courseData?.fileUrl) {
      const videoName = typeof courseData.fileUrl === 'string' ? courseData.fileUrl : String(courseData.fileUrl);
      setVideoFile({
        uid: 'video-0',
        name: videoName,
        status: 'done',
        url: videoName.startsWith('http') || videoName.startsWith('blob:') ? videoName : UPLOADS_URL + '/' + videoName,
      });
    } else {
      setVideoFile(null);
    }
  };

  const getCategories = async () => {
    setLoading(true);
    const res = await Get(`${CATEGORIES.getAllcategories}`, token, {
      limit: "100",
    });


    setCategories(res.data.docs);
    setLoading(false);
  };
  const deleteCourse = async () => {
    Delete(COURSE.deleteCourse + id, token)
      .then((response) => {
        if (response?.status) {
          swal("Success!", "Course Deleted Successfully", "success");
          navigate("/course-management");
        } else {
          swal("Oops!", response.message, "error");
        }
      })
      .catch((e) => {
        const message = e?.response?.data?.message || e?.message;
        if (message) {
          swal("Oops!", message, "error");
        }
      });
  };

  const handleStatus = async () => {
    try {
      const response = await Get(
        COURSE.toggleStatus + "/" + course._id,
        token,
        {}
      );
      console.log(response);
      const newUser = { ...course };

      newUser.isActive = !course.isActive;
      setModalOpen(false);
      setCourse(newUser);
    } catch (error) {
      console.log(error.message);
    }
  };

  const onFinish = (values) => {
    const formObject = new FormData();
    
    // Handle legacy image field (for backwards compatibility)
    if (imageNew) {
      formObject.append("image", values.image.fileList[0].originFileObj);
    }
    
    // Handle single video
    if (deleteVideo) {
      formObject.append("deleteVideo", "true");
    } else if (videoFile && videoFile.originFileObj) {
      // New video file replaces existing one
      formObject.append("video", videoFile.originFileObj);
    }
    
    // Handle thumbnail
    if (deleteThumbnail) {
      formObject.append("deleteThumbnail", "true");
    } else if (thumbnailFile && thumbnailFile.originFileObj) {
      formObject.append("thumbnail", thumbnailFile.originFileObj);
    }
    
    formObject.append("features", JSON.stringify(values?.features));
    formObject.append("availability", JSON.stringify(values?.availability));
    formObject.append("categories", JSON.stringify(values?.categories));
    
    for (const key in values) {
      if (
        key !== "image" &&
        key !== "features" &&
        key !== "video" &&
        key !== "categories" &&
        key !== "availability" &&
        key !== "thumbnail"
      ) {
        const item = values[key];
        formObject.append(key, item);
      }
    }

    // Handle files
    const prevFiles = fileList
      ?.filter((x) => !Boolean(x.size))
      ?.map((x) => x.name);
    const newFiles = fileList?.filter((x) => Boolean(x.size));
    
    // Add deleted files array
    if (deletedFiles.length > 0) {
      formObject.append("deletedFiles", JSON.stringify(deletedFiles));
    }
    
    formObject.append("previousfiles", JSON.stringify(prevFiles));
    newFiles?.forEach((file) => {
      formObject.append("files", file.originFileObj);
    });

    Post(
      COURSE.updateCourse + id,
      formObject,
      token,
      null,
      CONTENT_TYPE.FORM_DATA
    )
      .then((response) => {
        if (response?.data?.status) {
          swal("Success!", "Course Updated Successfully", "success");
          getCourse();
          setDeleteVideo(false);
          setDeletedFiles([]);
          setDeleteThumbnail(false);
          setThumbnailFile(null);
          setThumbnailPreview(null);
          setVideoFile(null);
          setEditMode(false);
          setImageNew();
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch((e) => {});
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const uploadOptions = {
    name: "file",
    multiple: true,
    onChange(info) {
      const newFileList = [...info.fileList];
      
      // Track deleted files
      const currentFileNames = course?.files || [];
      const remainingFileNames = newFileList
        .filter(f => !f.originFileObj) // Existing files don't have originFileObj
        .map(f => f.name);
      const deleted = currentFileNames.filter(f => !remainingFileNames.includes(f));
      setDeletedFiles(deleted);
      
      setFileList(newFileList);
    },
    onRemove(file) {
      // If it's an existing file (no originFileObj), add to deletedFiles
      if (!file.originFileObj && file.name) {
        setDeletedFiles(prev => [...prev, file.name]);
      }
    },
    beforeUpload(file) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        message.error(`${file.name} is not a valid file type.`);
        return Upload.LIST_IGNORE;
      }
      return false; // Prevent auto upload
    },
  };

  const videoUploadOptions = {
    name: "video",
    multiple: false,
    maxCount: 1,
    accept: "video/*",
    fileList: videoFile ? [videoFile] : [],
    showUploadList: false,
    beforeUpload: () => false, // Prevent auto upload
    onChange(info) {
      if (info.fileList.length > 0) {
        const file = info.fileList[0];
        // If it's a new file, create blob URL for preview
        if (file.originFileObj) {
          const blobUrl = URL.createObjectURL(file.originFileObj);
          setVideoFile({
            ...file,
            url: blobUrl,
          });
        } else {
          setVideoFile(file);
        }
        setDeleteVideo(false);
      } else {
        // If removing existing video, mark for deletion
        if (videoFile && !videoFile.originFileObj) {
          setDeleteVideo(true);
        }
        setVideoFile(null);
      }
    },
    onRemove() {
      // If it's an existing video (no originFileObj), mark for deletion
      if (videoFile && !videoFile.originFileObj) {
        setDeleteVideo(true);
      }
      setVideoFile(null);
    },
  };

  const thumbnailUploadOptions = {
    name: "thumbnail",
    listType: "picture-card",
    maxCount: 1,
    fileList: thumbnailFile ? [thumbnailFile] : [],
    showUploadList: false,
    beforeUpload: (file) => {
      // Create preview URL for real-time display
      const reader = new FileReader();
      reader.onload = (e) => {
        setThumbnailPreview(e.target.result);
      };
      reader.readAsDataURL(file);
      setThumbnailFile({ ...file, uid: file.uid || Date.now() });
      setDeleteThumbnail(false);
      return false; // Prevent auto upload
    },
    onChange(info) {
      if (info.fileList.length > 0) {
        setThumbnailFile(info.fileList[0]);
        setDeleteThumbnail(false);
      } else {
        setThumbnailFile(null);
        setThumbnailPreview(null);
      }
    },
  };
  const checkBoxOptions = [
    {
      label: "In-Person (Instructor-Led)",
      value: "In-Person (Instructor-Led)",
    },
    { label: "Virtual (Instructor-Led)", value: "Virtual (Instructor-Led)" },
    { label: "On-Demand (Self-Paced)", value: "On-Demand (Self-Paced)" },
    { label: "Hybrid (Blended Format)", value: "Hybrid (Blended Format)" },
  ];
  const checkboxChange = (checkedValues) => {
    console.log("checked = ", checkedValues);
  };
  return (
    <Layout className="configuration">
      <div className="boxDetails">
        <Row
          className="whiteBackground"
          style={{ backgroundColor: "white", justifyContent: "center" }}
        >
          <Col xs={24} md={22}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                padding: "100px 20px",
              }}
            >
              <Row style={{ padding: "10px 20px" }}>
                <Col
                  xs={24}
                  md={12}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <FaArrowLeft
                    style={{ fontWeight: "bold", fontSize: "20px" }}
                    onClick={() => navigate(-1)}
                  />
                  &emsp;
                  <h1 className="pageTitle" style={{ margin: 0 }}>
                    {editMode ? "Edit Course Details" : "View Course Details"}
                  </h1>
                </Col>
              </Row>
              <Button
                onClick={deleteCourse}
                type="button"
                style={{
                  color: "#d52727",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "auto",
                }}
              >
                <AiFillDelete
                  style={{
                    fontSize: "25px",
                    color: "#d52727",
                    marginLeft: "auto",
                  }}
                />{" "}
                Delete
              </Button>
              <br />

              {loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <Skeleton active paragraph={{ rows: 10 }} />
                </div>
              )}

              {!loading && course && (
                <>
                  {/* Thumbnail at top - Non-edit mode */}
                  {!editMode && (course.thumbnail || course.image) && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Image
                          src={
                            course.thumbnail
                              ? UPLOADS_URL + "/" + course.thumbnail
                              : course.image
                              ? UPLOADS_URL + "/" + course.image
                              : ImageUrl("avatar.png")
                          }
                          alt="Course thumbnail"
                          style={{ 
                            maxWidth: "400px",
                            width: "100%", 
                            height: "auto",
                            display: "block",
                            objectFit: "cover"
                          }}
                          preview={false}
                        />
                      </Col>
                    </Row>
                  )}

                  {/* Course Details - Non-edit mode (below thumbnail) */}
                  {!editMode && (
                    <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                      <Col xs={24}>
                        <Row gutter={[24, 24]}>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Course Code
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.courseCode}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Title
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.title}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Description
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.description}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Course Outline
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.courseOutline}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Category
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.categories?.map(cat => cat.title).join(", ") || "N/A"}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Start Date
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.startDate ? dayjs(course.startDate).format("MM/DD/YYYY") : "N/A"}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Duration
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.duration}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Price
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              ${course?.price}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Features
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.features?.join(", ") || "N/A"}
                            </h5>
                          </Col>
                          <Col xs={24} md={12}>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 10,
                              }}
                            >
                              Availability
                            </h5>
                            <h5
                              style={{
                                display: "block",
                                fontSize: 16,
                                color: "#7a7e7f",
                                fontWeight: "normal",
                              }}
                            >
                              {course?.availability?.join(", ") || "N/A"}
                            </h5>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {/* Video - Non-edit mode */}
                  {!editMode && course.fileUrl && (
                    <Row style={{ padding: "0 40px", marginBottom: "40px" }}>
                      <Col xs={24}>
                        <Typography.Title
                          className="fontFamily1"
                          style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            color: "#333d47",
                            marginBottom: 20,
                          }}
                        >
                          Video
                        </Typography.Title>
                        <div style={{
                          maxWidth: "800px",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          backgroundColor: "#fff"
                        }}>
                          <VideoPlayer data={course} />
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Documents Grid - Non-edit mode */}
                  {!editMode && (
                    <Row style={{ padding: "0 40px", marginBottom: "40px" }}>
                      <Col xs={24}>
                        <Typography.Title
                          className="fontFamily1"
                          style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            color: "#333d47",
                            marginBottom: 20,
                          }}
                        >
                          Documents
                        </Typography.Title>
                        {course.files && course.files.length > 0 ? (
                          <Row gutter={[16, 16]}>
                            {course.files.map((file, index) => {
                              const fileExtension = file.split('.').pop()?.toLowerCase();
                              const isPdf = fileExtension === 'pdf';
                              const fileName = file.split('/').pop() || file;
                              return (
                                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                  <a
                                    href={UPLOADS_URL + "/" + file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "block",
                                      textDecoration: "none",
                                      color: "inherit"
                                    }}
                                  >
                                    <div style={{
                                      padding: "20px",
                                      backgroundColor: "#fff",
                                      borderRadius: "10px",
                                      border: "1px solid #e8e8e8",
                                      textAlign: "center",
                                      transition: "all 0.3s ease",
                                      cursor: "pointer",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center"
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.borderColor = "#1890ff";
                                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(24,144,255,0.2)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.borderColor = "#e8e8e8";
                                      e.currentTarget.style.boxShadow = "none";
                                    }}
                                    >
                                      {isPdf ? (
                                        <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "12px" }} />
                                      ) : (
                                        <FileTextOutlined style={{ fontSize: "48px", color: "#1890ff", marginBottom: "12px" }} />
                                      )}
                                      <Typography.Text
                                        style={{
                                          display: "block",
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          color: "#333",
                                          wordBreak: "break-word",
                                          textAlign: "center"
                                        }}
                                      >
                                        {fileName}
                                      </Typography.Text>
                                    </div>
                                  </a>
                                </Col>
                              );
                            })}
                          </Row>
                        ) : (
                          <Typography.Text style={{ color: "#999", fontSize: "14px" }}>
                            No documents available
                          </Typography.Text>
                        )}
                      </Col>
                    </Row>
                  )}

                  <Form
                    layout="vertical"
                    name="basic"
                    className="contactForm"
                    labelCol={{
                      span: 0,
                    }}
                    wrapperCol={{
                      span: 24,
                    }}
                    initialValues={{
                      availability: course?.availability || [],
                      remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Row style={{ padding: "20px" }}>
                      <Col xs={24}>
                        {/* Thumbnail at top - Edit mode with upload */}
                        {editMode && (
                          <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                            <Col xs={24}>
                              <Typography.Title
                                className="fontFamily1"
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "#333d47",
                                  marginBottom: 15,
                                }}
                              >
                                Thumbnail
                              </Typography.Title>
                              <Form.Item name="thumbnail" style={{ marginBottom: 0 }}>
                                <div style={{ 
                                  width: "100%", 
                                  maxWidth: "800px",
                                }}>
                                  <Upload.Dragger 
                                    {...thumbnailUploadOptions} 
                                    maxCount={1}
                                    style={{
                                      padding: (thumbnailPreview || ((course.thumbnail || course.image) && !deleteThumbnail)) ? "0" : "60px 20px",
                                      minHeight: (thumbnailPreview || ((course.thumbnail || course.image) && !deleteThumbnail)) ? "400px" : "200px"
                                    }}
                                  >
                                    {(thumbnailPreview || ((course.thumbnail || course.image) && !deleteThumbnail)) ? (
                                      <div style={{ 
                                        position: "relative", 
                                        width: "100%",
                                        height: "400px",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#f5f5f5"
                                      }}>
                                        <img
                                          src={thumbnailPreview || (course.thumbnail ? (UPLOADS_URL + "/" + course.thumbnail) : (UPLOADS_URL + "/" + course.image))}
                                          alt="Thumbnail"
                                          style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            width: "auto",
                                            height: "auto",
                                            objectFit: "contain",
                                            display: "block"
                                          }}
                                        />
                                        <Button
                                          type="text"
                                          danger
                                          icon={<CloseOutlined />}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setThumbnailFile(null);
                                            setThumbnailPreview(null);
                                            if (course?.thumbnail || course?.image) {
                                              setDeleteThumbnail(true);
                                            }
                                          }}
                                          style={{
                                            position: "absolute",
                                            top: "8px",
                                            right: "8px",
                                            zIndex: 10,
                                            backgroundColor: "rgba(255, 255, 255, 0.9)",
                                            borderRadius: "50%",
                                            width: "32px",
                                            height: "32px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <>
                                        <p className="ant-upload-drag-icon">
                                          <UploadOutlined style={{ fontSize: "48px", color: "#1890ff" }} />
                                        </p>
                                        <p className="ant-upload-text" style={{ fontSize: "16px", marginTop: "16px" }}>
                                          Click or drag thumbnail image to this area to upload
                                        </p>
                                        <p className="ant-upload-hint" style={{ fontSize: "14px", color: "#999" }}>
                                          Support for single image upload. Recommended size: 800x400px
                                        </p>
                                      </>
                                    )}
                                  </Upload.Dragger>
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {editMode && <Divider style={{ margin: "30px 0" }} />}

                        {/* Inputs below thumbnail - Edit mode */}
                        {editMode && (
                          <Row style={{ padding: "0 40px", marginBottom: "30px" }}>
                            <Col xs={24}>
                              <Row gutter={20}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Course Code :
                                  </Typography.Title>

                                  <Form.Item
                                    name="courseCode"
                                    initialValue={course?.courseCode}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input your Course Code",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter CourseCode"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Title :
                                  </Typography.Title>

                                  <Form.Item
                                    name="title"
                                    initialValue={course?.title}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input course title",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter Title"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Row gutter={20}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Description:
                                  </Typography.Title>

                                  <Form.Item
                                    name="description"
                                    initialValue={course?.description}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please input Course description",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter Description"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Categories :
                                  </Typography.Title>

                                  <Form.Item
                                    name="categories"
                                    initialValue={
                                      course?.categories?.map((cat) => cat._id) ||
                                      []
                                    }
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input course categories",
                                      },
                                    ]}
                                  >
                                    <Select
                                      mode="multiple"
                                      placeholder="Select Categories"
                                      className="signupSelectBox"
                                    >
                                      {categories.map((item) => (
                                        <Option key={item._id} value={item._id}>
                                          {item.title}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Row gutter={20}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Start Date :
                                  </Typography.Title>

                                  <Form.Item
                                    name="startDate"
                                    initialValue={dayjs(course?.startDate)}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input start Date",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      style={{ width: "100%" }}
                                      size="large"
                                      placeholder="Enter start Date"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Duration :
                                  </Typography.Title>

                                  <Form.Item
                                    name="duration"
                                    initialValue={course?.duration}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input course duration",
                                      },
                                    ]}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter Duration"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Row gutter={20}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Price :
                                  </Typography.Title>

                                  <Form.Item
                                    name="price"
                                    initialValue={course?.price}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input price",
                                      },
                                    ]}
                                  >
                                    <Input
                                      prefix="$"
                                      size="large"
                                      placeholder="Enter Price"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Course Outline :
                                  </Typography.Title>

                                  <Form.Item
                                    name="courseOutline"
                                    initialValue={course?.courseOutline}
                                    style={{ width: "100%" }}
                                  >
                                    <Input
                                      size="large"
                                      placeholder="Enter Course Outline"
                                      className="signupFormInput"
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              <Row gutter={20}>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Features :
                                  </Typography.Title>

                                  <Form.Item
                                    name="features"
                                    initialValue={course?.features || []}
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input Features",
                                      },
                                    ]}
                                  >
                                    <Select
                                      mode="tags"
                                      style={{
                                        width: "100%",
                                      }}
                                      placeholder="Enter Features"
                                      className="tag-input"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={24}
                                  sm={12}
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      color: "black",
                                      textAlign: "left",
                                      marginBottom: 20,
                                    }}
                                  >
                                    Availability :
                                  </Typography.Title>
                                  <Form.Item
                                    name="availability"
                                    style={{ width: "100%" }}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please select availability",
                                      },
                                    ]}
                                  >
                                    <Checkbox.Group
                                      options={checkBoxOptions}
                                      onChange={checkboxChange}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        )}
                        {editMode && <Divider style={{ margin: "30px 0" }} />}

                        {editMode && (
                          <>
                            {/* Video Section */}
                            <Row gutter={30} style={{ padding: "0 20px", marginBottom: "30px" }}>
                              <Col xs={24}>
                                <Typography.Title
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#333d47",
                                    marginBottom: 20,
                                  }}
                                >
                                  Video
                                </Typography.Title>
                                
                                {/* Single Video Display */}
                                {videoFile && !deleteVideo ? (
                                  <div style={{
                                    position: "relative",
                                    maxWidth: "800px",
                                    marginBottom: "20px",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    backgroundColor: "#fff"
                                  }}>
                                    {/* Close Icon */}
                                    <Button
                                      type="text"
                                      danger
                                      icon={<CloseOutlined />}
                                      onClick={() => {
                                        if (!videoFile.originFileObj) {
                                          // Existing video - mark for deletion
                                          setDeleteVideo(true);
                                        }
                                        setVideoFile(null);
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: "8px",
                                        right: "8px",
                                        zIndex: 10,
                                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                                        borderRadius: "50%",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                      }}
                                    />
                                    {!videoFile.originFileObj ? (
                                      <VideoPlayer data={course} />
                                    ) : (
                                      <VideoPlayer 
                                        data={{ 
                                          fileUrl: videoFile.url,
                                        }} 
                                      />
                                    )}
                                  </div>
                                ) : null}
                                
                                {/* Upload Video Button */}
                                <div style={{ textAlign: "left", marginTop: videoFile ? "10px" : "0" }}>
                                  <Form.Item name="video" style={{ marginBottom: 0 }}>
                                    <Upload {...videoUploadOptions}>
                                      <Button 
                                        icon={<UploadOutlined />}
                                        type="primary"
                                        size="large"
                                        style={{
                                          borderRadius: "6px",
                                          padding: "0 30px"
                                        }}
                                      >
                                        {videoFile ? "Replace Video" : "Add Video"}
                                      </Button>
                                    </Upload>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                            <Divider style={{ margin: "30px 0" }} />

                            {/* Documents Grid */}
                            <Row gutter={30} style={{ padding: "0 20px", marginBottom: "30px" }}>
                              <Col xs={24}>
                                <Typography.Title
                                  className="fontFamily1"
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#333d47",
                                    marginBottom: 20,
                                  }}
                                >
                                  Documents
                                </Typography.Title>
                                
                                {/* Documents Grid */}
                                {fileList.length > 0 && (
                                  <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
                                    {fileList.map((file, idx) => {
                                      const isDeleted = deletedFiles.includes(file.name);
                                      const fileExtension = file.name?.split('.').pop()?.toLowerCase();
                                      const isPdf = fileExtension === 'pdf';
                                      return (
                                        <Col xs={24} sm={12} md={8} lg={6} key={file.uid || idx}>
                                          <div style={{
                                            position: "relative",
                                            padding: "20px",
                                            backgroundColor: isDeleted ? "#fff1f0" : "#fff",
                                            borderRadius: "10px",
                                            border: `1px solid ${isDeleted ? "#ffccc7" : "#e8e8e8"}`,
                                            textAlign: "center",
                                            opacity: isDeleted ? 0.5 : 1,
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            {/* Close Icon */}
                                            <Button
                                              type="text"
                                              danger
                                              icon={<CloseOutlined />}
                                              onClick={() => {
                                                if (!file.originFileObj && file.name) {
                                                  setDeletedFiles(prev => {
                                                    if (!prev.includes(file.name)) {
                                                      return [...prev, file.name];
                                                    }
                                                    return prev;
                                                  });
                                                } else {
                                                  setFileList(prev => prev.filter((_, i) => i !== idx));
                                                }
                                              }}
                                              style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                zIndex: 10,
                                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                borderRadius: "50%",
                                                width: "32px",
                                                height: "32px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                              }}
                                            />
                                            {isPdf ? (
                                              <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f", marginBottom: "12px" }} />
                                            ) : (
                                              <FileTextOutlined style={{ fontSize: "48px", color: "#1890ff", marginBottom: "12px" }} />
                                            )}
                                            <Typography.Text
                                              style={{
                                                display: "block",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                color: "#333",
                                                wordBreak: "break-word",
                                                textAlign: "center"
                                              }}
                                            >
                                              {file.name}
                                            </Typography.Text>
                                          </div>
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                )}
                                
                                {/* Add Documents Button - Centered */}
                                <div style={{ textAlign: "center" }}>
                                  <Upload {...uploadOptions} fileList={fileList} showUploadList={false}>
                                    <Button 
                                      icon={<UploadOutlined />}
                                      size="large"
                                      style={{
                                        borderRadius: "6px",
                                        padding: "0 30px"
                                      }}
                                    >
                                      {fileList.length > 0 ? "Add More Documents" : "Add Documents"}
                                    </Button>
                                  </Upload>
                                </div>
                              </Col>
                            </Row>
                          </>
                        )}
                        <br />
                        {editMode ? (
                          <>
                            {/* Inputs are now shown above, below thumbnail */}
                          </>
                        ) : (
                          <>
                            {/* Course details are now shown above in non-edit mode, below thumbnail */}
                          </>
                        )}

                        <Row style={{ marginTop: 30 }}>
                          {editMode && (
                            <>
                              {" "}
                              <Button
                                type="primary"
                                htmlType="submit"
                                className="loginButton"
                              >
                                Save Changes
                              </Button>
                              &emsp;
                              <Button
                                className="fontFamily1"
                                style={{
                                  marginTop: "0px",
                                  padding: "10px 30px",
                                  cursor: "pointer",
                                  color: "black",
                                  borderRadius: "5px",
                                  height: "auto",
                                  border: "1px solid #203657",
                                  fontWeight: "bold",
                                }}
                                ghost
                                size="large"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEditMode(false);
                                  // Reset deletion tracking when canceling
                                  setDeleteVideo(false);
                                  setDeletedFiles([]);
                                  setDeleteThumbnail(false);
                                  setThumbnailFile(null);
                                  setThumbnailPreview(null);
                                  setVideoFile(null);
                                  // Reload course data to reset video
                                  getCourse();
                                }}
                              >
                                Cancel
                              </Button>
                            </>
                          )}
                          {!editMode && (
                            <Row justify={"center"}>
                              <Col style={{ textAlign: "center" }}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  className="loginButton"
                                  onClick={() => {
                                    // Ensure videoFile is initialized when entering edit mode
                                    if (!videoFile && course?.fileUrl) {
                                      const videoName = typeof course.fileUrl === 'string' ? course.fileUrl : String(course.fileUrl);
                                      setVideoFile({
                                        uid: 'video-0',
                                        name: videoName,
                                        status: 'done',
                                        url: videoName.startsWith('http') || videoName.startsWith('blob:') ? videoName : UPLOADS_URL + '/' + videoName,
                                      });
                                    }
                                    setEditMode(true);
                                  }}
                                >
                                  Edit Course
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </>
              )}

              <br />
              <br />
            </div>
          </Col>
        </Row>
      </div>
      {!editMode && <Comments courseId={id} />}
      <Modal
        open={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Image
          // src="../images/question.png"
          src={ImageUrl("question.png")}
          preview={false}
          width={100}
          height={120}
        />
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {course?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {course?.isActive ? "Deactivate" : "Activate"} This
          User?
        </Typography.Text>
      </Modal>

      <br />
      <br />
    </Layout>
  );
}
export default CourseDetails;



const createFileList = (arr) => {
  if (!Array.isArray(arr)) return [];
  return arr.map((item) => ({
    uid: `${item}-${Math.random().toString(36).substr(2, 9)}`,
    name: item,
    status: "done",
    url: `${UPLOADS_URL}/${item}`,
  }));
};
